export function getVimeoIdFromUri(uri:string) {
    const parts = uri.split('/');
    return parts[parts.length - 1];
}
